import React from "react";

import { Col, Row } from "react-bootstrap";

import styles from "@pages/dashboard/DetailsDrawer.module.scss";

interface FormsHeaderProps {
  isInsertMode: boolean;
  title: string;
  className?: string;
}

const FormsHeader: React.FC<FormsHeaderProps> = ({ isInsertMode, title, className }) => {
  return (
    <>
      {isInsertMode ? (
        <Row className={className ? className : "mb-5"}>
          <Col>
            <h1 className="text-center">{title}</h1>
          </Col>
        </Row>
      ) : (
        <Row className="mb-3 mt-3">
          <Col>
            <h4 className={styles["stack-label"]}>{title}</h4>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FormsHeader;
